import React from 'react';
import styled from '@emotion/styled';
import { useTheme } from 'emotion-theming';
import { useSelector } from 'react-redux';
import IcomoonReact from 'icomoon-react';

import iconSet from '../../../../shared/images/teambuildr-selection.json';
import Text from '../../../../shared/_TBComponents/Text';

const StatusIndicatorContainer = styled('div')`
  position: fixed;
  bottom: 20px;
  right: 52px;
  display: flex;
  justify-content: space-between;
  width: auto;
  .circle {
    border-radius: 50%;
    height: 15px;
    width: 15px;
    display: block;
    margin-right: 5px;
    align-self: center;
    &.connected {
      background-color: ${(props) => props.theme.colors.green};
    }
    &.disconnected {
      background-color: ${(props) => props.theme.colors.red};
    }
  }
  @media screen and (max-width: 768px) {
    right: 24px;
  }
`;

const StatusIndicator = () => {
  const isConnected = useSelector((state) => state.socketTester.feedUi.isConnected);
  const theme = useTheme();

  return (
    <StatusIndicatorContainer aria-label={`Connection status: ${isConnected ? 'Connected' : 'Disconnected'}`}>
      <IcomoonReact
        iconSet={iconSet}
        size={15}
        icon='swap'
        color={theme.colors.lightText[0]}
      />
      <Text styledTextProps={{ marginLeft: '10px' }}>
        <span className={isConnected ? 'circle connected' : 'circle disconnected'} />
      </Text>
    </StatusIndicatorContainer>
  );
};

export default StatusIndicator;
